
import { Vue, Component, Prop } from 'vue-property-decorator';
import { copyTextToClipboard } from '../helpers';

@Component
export default class CopyToClipboardButton extends Vue {
  @Prop({ required: true }) text!: string;

  private isCopied = false;

  private copyApiKeyToClipboard(text: string) {
    copyTextToClipboard(text);

    this.isCopied = true;
    setTimeout(() => {
      this.isCopied = false;
    }, 3000);
  }
}

